import { render, staticRenderFns } from "./AppealModal.vue?vue&type=template&id=2b8d53f3&"
import script from "./AppealModal.vue?vue&type=script&lang=js&"
export * from "./AppealModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports